/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import EventService from '../../../../services/EventService';
import MasterService from '../../../../services/MasterService';
import moment from "moment";
import { Chart } from "react-google-charts";
import { showLoading } from 'react-global-loading';

class MissionEvents extends React.Component {

  constructor(props) {
    super(props);
    const url = new URL(window.location);
    showLoading(true);
    this.state = {
      eventsList: [],
      filteredList: [],
      upcoming: '',
      filterPincode: '',
      categories: [],
      selectedCategory: '', approved: '', pending: '',
      data: [
        ["months", "Approved", "Disapproved"],
        ["Jan", 400, 400],
        ["Feb", 700, 460],
        ["Mar", 660, 0],
        ["Apr", 870, 540],
        ["May", 400, 400],
        ["Jun", 700, 460],
        ["Jul", 660, 0],
        ["Aug", 870, 540],
        ["Sept", 400, 400],
        ["Oct", 700, 460],
        ["Nov", 660, 0],
        ["Dec", 870, 540],
      ],
      chart: {
        title: "Company Performance",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
      }, fullyLoaded: false, currentPage: url.searchParams.get('page') ? parseInt(url.searchParams.get('page')) : 1, statusType: 1, statusCount: {},
    };
  }

  componentDidMount = () => {
    // this.getEventList(this.state.currentPage, this.state.statusType);
    this.getCategories();
    this.filterdata()
  };

  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {

        console.error(err);
      });
  };

  getEventList = (query) => {
    showLoading(true);
    EventService.getAllEvents(query)
      .then((result) => {
        if (!result) {
          return;
        }

        this.setState({ filteredList: result.data, statusCount: result })
        showLoading(false);
      })
      .catch((err) => {
        showLoading(false);
        console.error(err);
      });
  };

  filterdata = (cat) => {

    const url = new URL(window.location);
    cat ? url.searchParams.set('cat', cat) : url.searchParams.delete('cat')

    url.searchParams.delete('page')
    this.setState({ currentPage: 1 })
    let query = {};
    this.setState({ query })
    cat && (query.category = cat);

    this.state.searchQuery && (query.s = this.state.searchQuery);
    this.getEventList(query)
    window.history.pushState(null, '', url.toString());

  }


  addEvent = () => {
    this.props.history.push({
      pathname: '/super/create-event'
    });
  };

  onLoad = () => {
    let currentPage = this.state.currentPage;
    currentPage++;
    this.setState({ currentPage })

    const url = new URL(window.location);
    url.searchParams.set('page', currentPage);
    window.history.pushState(null, '', url.toString());
    // this.setState(
    //   prev => ({
    //     ...prev,
    //     query: {
    //       ...prev.query,
    //       ...{ page: parseInt(this.state.currentPage) + 1 }
    //     }
    //   }))
    let currentQuery = this.state.query;
    // this.setState(prevState => ({
    //   query: {
    //     ...prevState.query,
    //     page: currentPage
    //   }
    // }));
    currentQuery.page = currentPage;
    this.setState({ query: currentQuery });
    // this.filterdata();
    // this.getProductList(query);
    EventService.getAllEvents(this.state.query)
      .then((result) => {
        if (!result) {
          return;
        }
        showLoading(true);
        this.setState((prevState) => ({
          statusCount: result,
          filteredList: [...prevState.filteredList, ...result.data]
        }));
        showLoading(false);
      })
      .catch((err) => {
        showLoading(false);
        console.error(err);
      });
  }

  render() {
    const { eventsList, filteredList, filterPincode, categories, selectedCategory, data, pending, approved, upcoming, statusCount } = this.state;
    const finalEventList = filteredList.length > 0 ? filteredList : eventsList;
    let fullyLoaded;
    fullyLoaded = filteredList.length === statusCount.total ? true : false;

    return (
      <div className="container mt-5" >
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">All</li>
          </ol>
        </nav>
        <hr></hr> */}

        <div className="row contrast-ration-sol">
          <div className="col-md-10">
            <h3><b>Events</b></h3>
          </div>
          <div className="col-md-2 btr">
            <button className="card-link rounded rounded-2 w-100 btntxdsh darkbtn" onClick={() => this.addEvent()}> Add Event
            </button >
          </div>
        </div>

        {/* <div className="row mt-3">
          <div className="col-12">
            <div className="card p-2 rounded rounded-4">
              <div className="card-body">
                <h5 className="card-title fs-5 fw-normal text-dark">Views of Events</h5>
                <hr></hr>
                <Chart
                  chartType="Bar"
                  width="100%"
                  height="400px"
                  data={data}
                // options={options}
                />
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="row mt-3">
          <div className="col-12">
            <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="view-all-events-pane" onClick={() => this.eventType(1)} aria-selected="true">All<span className="badge text-bg-secondary rounded-circle p-2">{eventsList.length}</span></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="view-all-events-pane" onClick={() => this.eventType(3)} aria-selected="true">Approved <span className="badge text-bg-secondary rounded-circle p-2">{approved.length}</span></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="view-all-events-pane" onClick={() => this.eventType(2)} aria-selected="true">Pending <span className="badge text-bg-secondary rounded-circle p-2">{pending.length}</span></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="add-new-events-pane" onClick={() => this.eventType(4)} aria-selected="false">Upcoming <span className="badge text-bg-secondary rounded-circle p-2">{upcoming.length}</span></button>
              </li>
            </ul>
          </div>
        </div> */}
        <div className="tab-content bg-white mt-3" id="myTabContent">
          <div className="tab-pane fade show active" id="view-all-events-pane" role="tabpanel" aria-labelledby="view-all-events-pane">

            <div className="row mt-4 mx-1 p-2 border border-1 rounded rounded-4">
              <div className="col-12">
                <div className="row bg-light p-2">
                  <div className="col-md-9 d-flex align-items-center">
                    <h4>Events</h4>
                  </div>
                  <div className="col-md-3">
                    <select name='orderby' className='form-control' aria-label='Shop order' value={selectedCategory}
                      onChange={(e) => (this.setState({ selectedCategory: e.target.value }), this.filterdata(e.target.value))}>
                      <option defaultValue='selected' value=''> Search By Domain</option>
                      {categories.map((item, index) => <option key={index} value={item.name}>{item.name}</option>)}
                    </select>
                  </div>
                </div>
                {/* <div className="row mt-3 contrast-ration-sol m-ver-col">

                  <div className="col-md-8 sl-block">
                    <div className="form-group has-search search-location-block">
                      <span className="fa fa-search form-control-feedback"></span>
                      <input aria-labelledby="searchevents" id="searchevents" type="text" className="form-control adminsearchbox" placeholder="Search" />
                    </div>
                    <span className="divide"></span>
                    <div className="form-group has-search search-location-block">
                      <span className="fa fa-map-marker form-control-feedback"></span>
                      <input aria-labelledby="serachlocation" id="serachlocation" type="text" className="form-control adminlocationbox" value={filterPincode} onChange={(e) => this.setState({ filterPincode: e.target.value })} placeholder="Enter location or ZIP code" />
                    </div>
                    <div className="allsearchbtn"> <button type="button" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn" onClick={() => this.eventType(5)}>Search</button></div>
                  </div>
                </div> */}
              </div>
              <hr className="mt-3"></hr>
              <div className="row mt-3 eve-list">
                {finalEventList.map((item, index) => <div className="col-md-6" key={index}>
                  <div className="row">
                    <div className="col-md-2">
                      <div className="date-card">
                        <div className="month w-100">{moment(item.date_of_event || item?.start_date).format("MMM")}</div>
                        <div className="day d-block w-100">{moment(item.date_of_event || item?.start_date).format("DD")}</div>
                        <div className="status d-block w-100"> {item.post_status === "pending" ? "Pending" : "Approved"}</div>
                      </div>
                    </div>
                    <div className="col-md-10 border-bottom border-secondary-subtle ps-5 mpsless">
                      <h4 className="mb-3 crop-text"><Link to={{
                        pathname: "/super/event-details",
                        search: `?id=${item.ID}& =${item.select_country?.id}`,
                        state: { eventDetails: item }
                      }} >{item.post_title}</Link></h4>
                      <span className="eve-time">Time: <b className="text-dark"> {moment(item?.time_of_event || item?.start_time, ["HH:mm"]).format("hh:mm A")}</b></span>
                      <span className="eve-date mx-3">Date: <b className="text-dark">{moment(item.date_of_event || item?.start_date).format("Do MMM YYYY")}</b></span>
                      <small className="muted d-block mt-2">{item.select_state}, {item.select_country.blogname}</small>
                    </div>
                  </div>
                </div>)}
                {filteredList.length > 0 ? (fullyLoaded ? <span> </span> : <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#beeadc",
                      border: "none",
                      borderRadius: "10px",
                      padding: "10px 2rem",
                      fontWeight: "semibold",
                    }}
                    onClick={e => this.onLoad()}
                  >
                    Load More
                  </button>
                </div>) : ''}

              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }
}
export default MissionEvents;